'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('./colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isSelectionTruthy = function isSelectionTruthy(value) {
  return !(Array.isArray(value) && !value.length || value === null || value === undefined || value === '');
};

var isStateless = function isStateless(component) {
  return !component.prototype.render;
};

var SelectWrapper = function (_Component) {
  _inherits(SelectWrapper, _Component);

  function SelectWrapper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectWrapper.__proto__ || Object.getPrototypeOf(SelectWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.selectReference = null, _this.state = {
      shouldFloat: isSelectionTruthy(_this.props.value)
    }, _this.handleFocus = function () {
      _this.setState({ shouldFloat: true }, _this.props.onFocus);
    }, _this.handleBlur = function () {
      var value = _this.props.value;

      if (isSelectionTruthy(value)) {
        _this.setState({ shouldFloat: true }, _this.props.onBlur);
      } else {
        _this.setState({ shouldFloat: false }, _this.props.onBlur);
      }
    }, _this.handleInputKeyDown = function () {
      _this.setState({ shouldFloat: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectWrapper, [{
    key: 'focus',
    value: function focus() {
      if (this.selectReference) {
        this.selectReference.input.focus();
      }
    }
  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // eslint-disable-line camelcase
      this.setState({ shouldFloat: isSelectionTruthy(nextProps.value) });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var shouldFloat = this.state.shouldFloat;
      var _props = this.props,
          placeholder = _props.placeholder,
          label = _props.label,
          selectedSelect = _props.selectedSelect,
          required = _props.required,
          helpText = _props.helpText;

      var ref = isStateless(selectedSelect) ? undefined : function (select) {
        _this2.selectReference = select;
      };

      return _react2.default.createElement(
        'div',
        { className: 'react-select-wrapper form-group ' + (shouldFloat ? 'form-group-active' : '') },
        _react2.default.createElement(
          'label',
          { style: { pointerEvents: 'none' }, className: 'control-label' },
          placeholder || label,
          required ? _react2.default.createElement(
            'span',
            { style: { color: _colors.persimmon.base } },
            ' *'
          ) : ''
        ),
        _react2.default.createElement(selectedSelect, _extends({}, this.props, {
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onInputKeyDown: this.handleInputKeyDown,
          placeholder: '',
          ref: ref
        })),
        helpText ? _react2.default.createElement(
          'small',
          { className: 'help-block' },
          helpText
        ) : null
      );
    }
  }]);

  return SelectWrapper;
}(_react.Component);

exports.default = SelectWrapper;


SelectWrapper.propTypes = {
  required: _propTypes2.default.bool,
  selectedSelect: _propTypes2.default.func,
  label: _propTypes2.default.node,
  placeholder: _propTypes2.default.node,
  value: _propTypes2.default.any, // eslint-disable-line react/forbid-prop-types
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  helpText: _propTypes2.default.node
};